import React from "react";
import styled from "styled-components";
import { Avatar } from "@sonder/ui/source/styled/components/Avatar";
import { colors } from "@sonder/ui/source/styled/theme";

const Wrapper = styled.div`
  align-items: center;
  display: flex;
`;

const StyledAvatar = styled(Avatar)`
  margin-right: 0.75rem;
`;

export const Name = styled.div`
  color: ${colors.gray4};
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 12rem;
`;

export const Email = styled.div`
  color: ${colors.grayA};
`;

interface UserCardInDropdownItemProps {
  email?: string;
  imageUrl?: string | null;
  name?: string;
}

export const UserCardInDropdownItem = (props: UserCardInDropdownItemProps) => {
  const { email, imageUrl, name } = props;
  return (
    <Wrapper>
      <StyledAvatar imageUrl={imageUrl} name={name} />
      <div>
        <Name>{name}</Name>
        <Email>{email}</Email>
      </div>
    </Wrapper>
  );
};
